// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student-wrapper {
    padding-top: 20px;
}

.img-container {
    width: 120px;
    height: 135px;
    padding: 0px !important;
    display: flex;
    justify-content: center;
}

.profile-img {
    width: 120px;
    height: 135px;
}

.background-border {
    background-color: darkgrey;
    border-radius: 5px;
    margin: 10px;
    align-items: center;
    display: flex;
}

.medium-size {
    height: auto !important;
}
.import-file-container {
    margin-right: 20px;
}

.btn-sm {
    float: right;
    margin-top: 5px;
}

.file-name {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.dowload-file {
    color: #0d6efd;
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/Edit/Student.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B","sourcesContent":[".student-wrapper {\r\n    padding-top: 20px;\r\n}\r\n\r\n.img-container {\r\n    width: 120px;\r\n    height: 135px;\r\n    padding: 0px !important;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.profile-img {\r\n    width: 120px;\r\n    height: 135px;\r\n}\r\n\r\n.background-border {\r\n    background-color: darkgrey;\r\n    border-radius: 5px;\r\n    margin: 10px;\r\n    align-items: center;\r\n    display: flex;\r\n}\r\n\r\n.medium-size {\r\n    height: auto !important;\r\n}\r\n.import-file-container {\r\n    margin-right: 20px;\r\n}\r\n\r\n.btn-sm {\r\n    float: right;\r\n    margin-top: 5px;\r\n}\r\n\r\n.file-name {\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n}\r\n\r\n.dowload-file {\r\n    color: #0d6efd;\r\n    text-decoration: underline;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
